var render = function render(){var _vm=this,_c=_vm._self._c;return _c('channel-list',{ref:"channelList",attrs:{"compact":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }